import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Login.css";
import "../styles/CreatePassword.css";
// import Logo from "../assets/images/TCUK-Logo.png";
import { FaChevronLeft } from "react-icons/fa";
import giftIcon from "../assets/images/password-changed 1.png";
import HeaderLogo from "../components/HeaderLogo";

export default function CreatePassword() {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  const validateForm = () => {
    const newErrors = {};
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*]).{8,}$/;


    if (!password) {
      newErrors.password = "Password is required";
    } else if (!passwordRegex.test(password)) {
      newErrors.password =
        "must be 8+ chars, include uppercase, lowercase, number & special char";
    }

    if (!confirmPassword) {
      newErrors.confirmPassword = "Confirm Password is required";
    }else if (password !== confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      setShowModal(true);
    }
  };

  return (
    <div className="create-container">
      {/* Header */}
      {/* <div className="create-header">
        <img src={Logo} alt="TCUK Logo" className="header-logo" />
        <h1 className="create-title">TCUK SADMIN</h1>
      </div> */}
      <HeaderLogo/>

      {/* Card */}
      <div className="create-card">
        <div className="create-back" onClick={() => navigate("/")}>
            <FaChevronLeft className="back-icon" />
            <span className="back-text">Back</span>
        </div>
        
                
        <h2 className="create-heading">Create New Password</h2>
        <p className="create-subtext">
            Your new Password must be different from previous used passwords
        </p>

        {/* {errors.general && <p className="error">{errors.general}</p>} */}
        {/* <p className="error general-error">{errors.general || " "}</p> */}

        <form onSubmit={handleSubmit} className="create-form">

          <div className="create-input-wrapper">
            <label>New password</label>
            <input
              type="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            {/* {errors.password && <p className="error">{errors.password}</p>} */}
            <p className="error">{errors.password || " "}</p>
          </div>

          <div className="create-input-wrapper">
            <label>Confirm password</label>
            <input
              type="password"
              placeholder="Enter your password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
            {/* {errors.password && <p className="error">{errors.password}</p>} */}
            <p className="error">{errors.confirmPassword || " "}</p>
          </div>

          {/* <a
            href="#"
            className="forgot-password"
            onClick={() => navigate("/forgot-password")}
          >
            Forgot password?
          </a> */}


          <button type="submit" className="create-btn">
            Verify
          </button>
        </form>
      </div>
      {/* Modal */}
      {showModal && (
        <div className="modal-overlay">
          <div className="modal-box">
            <h2>Password Changed!</h2>
            <img
              src={giftIcon}
              alt="Gift Icon"
              className="reward-icon"
            />
            <p>Your password has been reset successfully.</p>
            <button
              className="modal-btn"
              onClick={() => {
                setShowModal(false);
                navigate("/");
              }}
            >
              Back to Login
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
